package com.vizio.redwolf.dms.model

import kotlinx.serialization.Serializable
import kotlin.js.JsExport

@Serializable
@JsExport
sealed class VoiceLinkingResponse {
    @Serializable
    class Success(
        val alexaEnabled: Boolean,
        val alexaSynced: Boolean,
        val googleAssistantEnabled: Boolean,
        val googleAssistantSynced: Boolean
    ) : VoiceLinkingResponse()

    @Serializable
    class Failure(
        val message: String? = null,
        val responseCode: String? = null
    ) : VoiceLinkingResponse()

    class Error(val exception: Throwable) : VoiceLinkingResponse()
    class Timeout(val exception: Throwable) : VoiceLinkingResponse()

    fun <R> fold(
        onSuccess: (Success: Success) -> R,
        onFailure: (Failure: Failure) -> R,
        onError: (Error: Error) -> R,
        onTimeout: (Timeout: Timeout) -> R
    ): R {
        return when (this) {
            is Success -> onSuccess(Success(this.alexaEnabled, this.alexaSynced, this.googleAssistantEnabled, this.googleAssistantSynced))
            is Failure -> onFailure(Failure(this.message))
            is Error -> onError(Error(this.exception))
            is Timeout -> onTimeout(Timeout(this.exception))
        }
    }
}